import { useTranslation } from '@hooks/useTranslation';
import LockIcon from '@mui/icons-material/Lock';
import { Box, Button, CircularProgress, Paper, Typography } from '@mui/material';
import { logoutUser } from '@redux/reducers/user.reducer';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

const Logout = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const sessionMismatch = searchParams.get('sessionMismatch') === 'true';
  const noSession = searchParams.get('noSession') === 'true';
  const noSeat = searchParams.get('noSeat') === 'true';
  const [countdown, setCountdown] = useState(20);
  const history = useHistory();
  const localeLogout = useTranslation('logout');

  useEffect(() => {
    dispatch(logoutUser());
    if (sessionMismatch || noSession || noSeat) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            history.push('/login');
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => {
        clearInterval(timer);
      };
    } else {
      history.push('/login');
    }
  }, [sessionMismatch, noSession, noSeat]);

  return (
    <Box className="min-h-screen w-full flex justify-center items-center bg-gray-50">
      {sessionMismatch || noSession || noSeat ? (
        <Paper elevation={3} className="p-8 max-w-md w-full mx-4 text-center">
          <LockIcon className="text-primary-600 mb-4" style={{ fontSize: 48 }} />

          <Typography variant="h5" className="font-semibold mb-4">
            {noSeat
              ? localeLogout['noSeatTitle']
              : sessionMismatch
                ? localeLogout['singleWindowPolicy']
                : localeLogout['noSessionDetected']}
          </Typography>

          <Typography variant="body1" className="text-gray-600 mb-6">
            {noSeat
              ? localeLogout['noSeatMessage']
              : sessionMismatch
                ? localeLogout['singleWindowMessage']
                : localeLogout['noSessionMessage']}
          </Typography>

          {sessionMismatch && (
            <Box className="bg-blue-50 p-4 rounded-lg mb-6 mt-6">
              <Typography variant="body2" className="text-blue-800">
                {localeLogout['securityNote']}
              </Typography>
              <ul className="text-left text-blue-800 mt-2 list-disc list-inside">
                <li>{localeLogout['policyPoints']['oneWindow']}</li>
                <li>{localeLogout['policyPoints']['invalidation']}</li>
                <li>{localeLogout['policyPoints']['unauthorized']}</li>
              </ul>
            </Box>
          )}

          <Typography variant="body2" className="text-gray-500 mb-4">
            {localeLogout['redirectingIn']} {countdown} {localeLogout['seconds']}
          </Typography>

          <Box className="flex justify-center gap-4 mt-4">
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                history.push('/login');
              }}>
              {localeLogout['loginNow']}
            </Button>
          </Box>
        </Paper>
      ) : (
        <Box className="text-center">
          <CircularProgress />
          <Typography variant="body1" className="mt-4 text-gray-600">
            {localeLogout['loggingOut']}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default Logout;
